"use client";

import React from "react";
import { CaseStudyData } from "../../data/case-studies/types";
import { MermaidRenderer } from "./mermaid-renderer";

interface CaseStudyArchitectureProps {
  caseStudy: CaseStudyData;
}

export function CaseStudyArchitecture({ caseStudy }: CaseStudyArchitectureProps) {
  return (
    <section className="py-24 md:py-36 border-b border-white/[0.08] bg-zinc-950/40">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        
        {/* Section Header */}
        <div className="mb-14 space-y-4">
          <span className="block font-mono text-xs uppercase tracking-wider text-zinc-500">
            System Topology
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white">
            {caseStudy.architecture.title}
          </h2>
          <p className="text-base sm:text-lg text-zinc-400 font-light max-w-3xl leading-relaxed">
            {caseStudy.architecture.description}
          </p>
        </div>

        {/* Technical Architecture Canvas with Product Theme Accent */}
        <div className="mb-14">
          <MermaidRenderer
            code={caseStudy.architecture.diagramCode}
            accentColor={caseStudy.accentHex}
          />
        </div>

        {/* Key Architectural Layers Grid with 1px Hairlines */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-8 border-t border-white/[0.08]">
          {caseStudy.architecture.keyLayers.map((layer, idx) => (
            <div key={idx} className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs text-zinc-500 uppercase tracking-wider">
                  Layer 0{idx + 1}
                </span>
                <span className="text-[11px] font-mono text-zinc-500">
                  {layer.tech}
                </span>
              </div>
              <h4 className="text-lg font-semibold text-white tracking-tight">
                {layer.name}
              </h4>
              <p className="text-sm text-zinc-400 font-light leading-relaxed">
                {layer.role}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
